import GetConsultingCasesByUserRequestModelBase from '../_generated/modelBases/get-consulting-cases-by-user-request-model-base';

export default class GetConsultingCasesByUserRequestModel extends GetConsultingCasesByUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
